import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LoadingService {
	showLoadingSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	apiQueue: number[] = [];

	show() {
		this.apiQueue.push(1);
		this.showLoadingSource.next(true);
	}

	hide() {
		this.apiQueue.pop();
    	this.showLoadingSource.next( Number(this.apiQueue.length) != 0 );
	}

	reset(){
		this.apiQueue = [];
		this.showLoadingSource.next( Number(this.apiQueue.length) != 0 );
	}
}
